import { render, staticRenderFns } from "./RegistrationHome.vue?vue&type=template&id=1faf80a1&scoped=true&"
import script from "./RegistrationHome.vue?vue&type=script&lang=js&"
export * from "./RegistrationHome.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationHome.vue?vue&type=style&index=0&id=1faf80a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf80a1",
  null
  
)

export default component.exports